import { assert_hash_sha256_not_empty, assert_number_gte_0, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_IMAGE_META__graph_field } from './DTO_IMAGE_META__graph_field';

export class DTO_IMAGE_META__graph_field_generated extends DTO_IMAGE_META__graph_field {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.IMAGE_META__GRAPH_FIELD_GENERATED;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  field_hash__value_full!: string;
  field_hash__value_clean!: string; //todo: use  clean settings for all nodes connected to to calc hash

  graph!: DTO_GRAPH__instance;

  gpu_name!: string;

  generation_duration!: number;

  /*
   * RUNTIME FIELDS
   */

  /*
   * PROPERTIES
   */

  /*
   * METHODS
   */
  constructor() {
    super();
    this.graph = DTO_GRAPH__instance.CREATE_STUB();
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_hash_sha256_not_empty(this.field_hash__value_full);
    assert_hash_sha256_not_empty(this.field_hash__value_clean);

    assert_string_not_empty(this.gpu_name);

    assert_number_gte_0(this.generation_duration);
  }
}
